/*
  tsconfig.json needs

  "compilerOptions": {
    ...
    "resolveJsonModule": true,
    "esModuleInterop": true,
    ...
  }

  added for these to work.
*/

import AppPackageJson from "../../package.json";
import GitHash from "../../githash.json";


export const AppPackage = Object.assign({
    devVersion: AppPackageJson.version + "-" + GitHash.githash.substring(0, 7)
}, AppPackageJson);
